import React from 'react';
import { auth } from '../firebase';

function ChatMessage({ message }) {
  const { text, uid, photoURL, displayName, createdAt } = message;
  const isSent = uid === auth.currentUser?.uid;
  const messageClass = isSent ? 'sent' : 'received';

  const formattedTime = createdAt?.toDate
    ? createdAt.toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '';

  return (
    <div className={`message ${messageClass}`}>
      <img
        src={photoURL || 'https://ui-avatars.com/api/?name=User&background=1e1e1e&color=888'}
        alt={displayName || 'avatar'}
        className="message-avatar"
      />
      <div className="message-body">
        {displayName && (
          <span className="message-name">{displayName}</span>
        )}
        <p className="message-bubble">{text}</p>
        {formattedTime && (
          <span className="message-time">{formattedTime}</span>
        )}
      </div>
    </div>
  );
}

export default ChatMessage;
